import { Typography, Box, Grid } from "@mui/material";
// TODO: Grid is saying its deprecated, but Grid2 link does not lead anywhere

import { TECH_TYPE_OPTIONS_ARRAY } from "common/constants/techTypes";
import { AppFormType } from "components/Forms/AppForm";

interface ProductDetailsSectionProps {
  productForm: AppFormType | { AppField: any };
}

let techTypeOptions = [];

techTypeOptions = TECH_TYPE_OPTIONS_ARRAY.map((techType) => ({
  value: techType,
  label: techType,
}));

const ProductDetailsSection = ({ productForm }: ProductDetailsSectionProps) => {
  return (
    <Box className="mb-4">
      {/* WARN: Custom styling from pre standardization! */}
      {/* TODO: Standardize when you come across this!  */}
      <Typography variant="body1" className="mb-2">
        PRODUCT DETAILS
      </Typography>
      <div className="border p-3 rounded">
        {/* WARN: Custom styling from pre standardization! */}
        {/* TODO: Standardize when you come across this!  */}
        <Typography variant="body1" sx={{ mb: 3, color: "text.secondary" }}>
          Include Administrative Guide, Product URL, or other information to
          prove details about the product to be evaluated.
        </Typography>
        <Grid container spacing={3}>
          <Grid item xs={12} md={6}>
            <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
              <productForm.AppField name="product_name">
                {(field: any) => (
                  <field.TextInput label="Product Name:" required />
                )}
              </productForm.AppField>
              <productForm.AppField name="tech_type">
                {(field: any) => (
                  <field.MultiAutocompleteSelect
                    options={techTypeOptions}
                    label="Recommended Technology Type:"
                    style={{ width: "100%" }}
                    size="small"
                    required
                  />
                )}
              </productForm.AppField>
            </Box>
          </Grid>
          <Grid item xs={12} md={6}>
            <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
              <productForm.AppField name="version">
                {(field: any) => (
                  <field.TextInput label="Product Version:" required />
                )}
              </productForm.AppField>
              <productForm.AppField name="url">
                {(field: any) => (
                  <field.TextInput label="Product URL:" type="url" required />
                )}
              </productForm.AppField>
            </Box>
          </Grid>
          <Grid item xs={12}>
            <productForm.AppField name="product_description">
              {(field: any) => (
                <field.HtmlEditor label="Product Description:" required />
              )}
            </productForm.AppField>
          </Grid>
        </Grid>
      </div>
    </Box>
  );
};

export default ProductDetailsSection;
